import { render, staticRenderFns } from "./DialogSignature.vue?vue&type=template&id=2097b246"
import script from "./DialogSignature.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogSignature.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports